/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
import AbstractResponsiveComponent from './AbstractResponsiveComponent';

class BannerTeaserContent extends Component {
	view(vnode) {
		return (
			<div className={this.attrs.className}>
				<p>
					{vnode.children}
					{m.trust(this.attrs.deviceData)}
				</p>
			</div>
		);
	}
}

export default class BannerTeaser extends AbstractResponsiveComponent {
	get data() {
		return this.attrs.banner.content()?.teaser;
	}

	getClassName() {
		return `${super.className} BannerTeaser`;
	}

	get content() {
		return BannerTeaserContent;
	}
}
